'use client';

import { Suspense } from 'react';
import { Connections } from '@/components/Connections';
import { PageSkeleton } from '@/components/PageSkeleton';
import { useChatPage } from '@/hooks/useChatPage';

export default function ConnectionsPage() {
  useChatPage('home');
  return (
    <div data-onboarding-connections-page>
      <Suspense fallback={<PageSkeleton />}>
        <Connections />
      </Suspense>
    </div>
  );
}
